import React, { useState, useContext, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import { useHistory } from "react-router-dom";

import api from "../../services/api";
import { UserContext } from "../../context/UserContext";
import isEmail from "../../utils/isEmail";
import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import { GlobalVariables } from "../../global";
import { userAuthentication } from "../../repositories/userRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import "./login.css";

const Login = ({ location }) => {
  const history = useHistory();
  const { setUser, logoutUser } = useContext(UserContext);
  const [email, setEmail] = useState(location.state || "");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [runLogout, setRunLogout] = useState(false);

  useEffect(() => {
    if (!runLogout) {
      logoutUser();
      setRunLogout(true);
    }
  }, [logoutUser, runLogout]);

  const onFormSubmit = async (e) => {
    try {
      e.preventDefault();

      const errorsLogin = {};
      let isValidated = true;

      if (!isEmail(email)) {
        isValidated = false;
        errorsLogin.email = true;
        notify("Digite um e-mail válido.", true, "error");
      }

      if (!password || password === "") {
        isValidated = false;
        errorsLogin.password = true;
        notify("Digite a senha.", true, "error");
      }

      setErrors(errorsLogin);
      if (!isValidated) return;

      setLoading(true);

      const { data: result } = await userAuthentication({ email, password });

      const data = result.data;

      if (!data) throw new Error();

      data.password = password;
      data.email = email;

      if (data.codMessage === GlobalVariables.ACCESS_FIRST) {
        setLoading(false);
        return history.push("/changePasswordAccessFirst", email);
      }

      setUser({
        Id: data.Id.toString(),
        Nome: data.Nome,
        Email: data.email,
        IdTipoUsuario: data.IdTipoUsuario.toString(),
        IdTipoPromotor: data.IdTipoPromotor.toString(),
        PromotorCNPJ: data.PromotorCNPJ,

        tokenValuesUser: data.tokenValuesUser,
        accessRoutes: data.accessRoutes.join(","),
        tokenCognito: data.authCognito.accessToken,
        refreshToken: data.authCognito.refreshToken,
      });

      api.setHeaders();

      setLoading(false);
      history.push("/homePage");
    } catch (error) {
      console.error("ERROR: Login", error);
      setLoading(false);
      setErrors({ email: true, password: true });
    }
  };

  return (
    <form onSubmit={onFormSubmit}>
      <div className="containerLogin">
        {loading && <ModalLoading loading={loading} />}
        <div className="containerFormLogin">
          <div className="imageBackgroudContainer">
            <div className="rightContainer">
              <div className="containerLogo">
                <img
                  alt="Plug"
                  src="img/QyonPlugLogin.png"
                  className="logoQyon"
                />
              </div>

              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextFieldCustom
                    label="E-mail"
                    autoFocus
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    error={errors.email}
                  />
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextFieldCustom
                    label="Senha"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    setValue={setPassword}
                    error={errors.password}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          className="eyePasswordIcon"
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <label
                className="linkRecoverPass"
                onClick={() => history.push("/recoverPassword")}
              >
                Esqueci minha senha
              </label>

              <button
                id="buttonLogin"
                disabled={loading}
                type="submit"
                className="btn btn-info btn-block"
              >
                Entrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Login;
